export const sorting = {
    'sort.newest': '最新',
    'sort.price': '价格',
    'sort.on.sale': '出售',
    'sort.number': '编号',
}
